import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PageService } from '@app/pages/services/page.service';
import { ThemeService } from '@shared/services/theme.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  cities = ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Extended'];
  defaultCity: string = this.cities[0];
  eventList: any[] = [];
  defaultImage = 'assets/images/default-img.jpg';
  cityData: { [key: string]: any } = {};
  cityParams: HttpParams;
  eventLimit = 15;
  activeFilter: string = '*';
  eventTags: string[] = [];
  pageLoad = 1;
  isLoading: boolean = true;
  showLoadMore: boolean = false;
  currentTheme: string;

  filterBtns = [
    { label: 'View All', icon: 'fa-sharp fa-regular fa-eye', filter: '*' },
    { label: 'Web', icon: 'fa-sharp fa-solid fa-earth-americas', filter: 'web' },
    { label: 'IOS', icon: 'fa-brands fa-apple', filter: 'ios' },
    { label: 'Android', icon: 'fa-brands fa-android', filter: 'android' },
    { label: 'Front End', icon: 'fa-brands fa-html5', filter: 'front-end' },
    { label: 'Security', icon: 'fa-sharp fa-solid fa-shield-halved', filter: 'security' }
  ];

  constructor(
    public themeService: ThemeService,
    private pageService: PageService,
    public router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.themeService.themes.subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.getEvents(this.defaultCity);
  }

  selectedFilter(filter: string): void {
    this.activeFilter = filter;
    if (this.defaultCity && this.cityData[this.defaultCity]) {
      this.filterEvents();
    } else {
      this.getEvents(this.defaultCity);
    }
    this.cdr.detectChanges();
  }

  getEvents(city: string) {
    this.activeFilter = '*';
    this.isLoading = true;
    this.showLoadMore = false;
    this.defaultCity = city;
    this.cityParams = new HttpParams().append('limit', this.eventLimit).append('edition', city);
    this.cityParams = this.cityParams.delete('offset');
    this.pageLoad = 1;
    this.pageService.getEventList(this.cityParams).subscribe(data => {
      this.isLoading = false;
      this.cityData[city] = data.results;
      if (data.next) {
        this.cityData.next = data.next;
        this.showLoadMore = true;
      }
      this.filterEvents();
    }, error => {
      console.error(error);
    });

  }

  loadMore() {
    if (this.cityData.next) {
      this.showLoadMore = false;
      const city = this.defaultCity;
      this.pageLoad += 1;
      const start = (this.pageLoad - 1) * this.eventLimit;
      this.cityParams = this.cityParams.delete('offset');
      this.cityParams = this.cityParams.append('offset', start.toString());
      this.pageService.getEventList(this.cityParams).subscribe(data => {
        this.isLoading = false;
        this.cityData[city] = this.cityData[city].concat(data.results);
        if (data.next) {
          this.cityData.next = data.next;
          this.showLoadMore = true;
        }
        this.cityData.next = data.next;
        this.filterEvents();
      }, error => {
        console.error(error);
      });
    }
  }

  onLoad(event: any) {
    event.isEventImgLoad = true;
  }

  filterEvents(): void {
    this.isLoading = true;
    const allEvents = this.cityData[this.defaultCity];
    if (this.activeFilter === '*') {
      this.isLoading = false;
      this.eventList = allEvents.filter((event: any) => event.status !== 'cancelled');
    } else {
      this.eventList = allEvents.filter((event: any) =>
        event.status !== 'cancelled' &&
        event.event_tags.some((tag: any) => tag.title === this.activeFilter)
      );
      this.isLoading = false;
    }
  }

  onError(event: any) {
    event.target.src = this.defaultImage;
  }

  routClick(id: any) {
    this.router.navigate(['/events/', id]);
  }

}
